module.exports = __webpack_public_path__ + "static/img/13c.33afa51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13c.jpg
// module id = 86Nc
// module chunks = 1